import DashboardActiveMainLaps from './components/laps';
import DashboardActiveMainCurrentLap from './components/current_lap';
import DashboardActiveMainBestLap from './components/best_lap';
import DashboardActiveMainGapAnalysis from './components/gap_analysis';
import DashboardActiveMainPedalsInputs from './components/pedals_inputs';
import DashboardActiveMainTrackStatus from './components/track_grip_status';

import DashboardActiveMainDriver from './components/driver';
import DashboardActiveMainSpeedGraph from './components/speed_graph';
import DashboardActiveMainTyres from './components/tyres';
import DashboardActiveMainCarDamage from './components/car_damage';

import DashboardActiveMainRPMandGear from './components/rpm_gear';
import DashboardActiveMainFuelSystem from './components/fuel';
import DashboardActiveMainStrategyFuelSystem from './components/fuel_strategy';
import DashboardActiveMainCarControls from './components/car_control';
import DashboardActiveMainBrakeBias from './components/brake_bias';

import DashboardActiveMainLeaderboard from './components/leaderboard';

function DashboardActiveMain( {value, userData, leaderboard} ) {
    return (
        <>
            <main className="flex flex-1 overflow-hidden">
                <aside className="w-72 border-r border-[#233648] bg-background-light dark:bg-background-dark p-4 flex flex-col gap-4 overflow-y-auto">
                    <DashboardActiveMainLaps value={value}/>

                    <div className="space-y-2">
                        <DashboardActiveMainCurrentLap value={value}/>

                        <DashboardActiveMainBestLap value={value}/>

                        <DashboardActiveMainGapAnalysis value={value}/>
                    </div>

                    <DashboardActiveMainPedalsInputs value={value}/>

                    <DashboardActiveMainTrackStatus value={value}/>
                </aside>

                <section className="flex-1 flex flex-col p-5 gap-4 overflow-y-auto bg-[#0d1117]">
                    <DashboardActiveMainDriver value={value}/>

                    <DashboardActiveMainSpeedGraph value={value}/>

                    <DashboardActiveMainTyres value={value} userData={userData}/>

                    <DashboardActiveMainCarDamage value={value} userData={userData}/>
                </section>

                <aside className="w-80 border-l border-[#233648] bg-background-light dark:bg-background-dark p-4 flex flex-col gap-6 overflow-y-auto">
                    <DashboardActiveMainRPMandGear value={value}/>
                    
                    <DashboardActiveMainFuelSystem value={value}/>

                    <DashboardActiveMainStrategyFuelSystem value={value} userData={userData}/>

                    <DashboardActiveMainCarControls value={value}/>

                    <DashboardActiveMainBrakeBias value={value}/>
                </aside>
            </main>
            
            <DashboardActiveMainLeaderboard value={value} leaderboard={leaderboard} userData={userData}/>
        </>
    );
}

export default DashboardActiveMain;